module.exports = __webpack_public_path__ + "static/og-39f4a7761a43c5919c07a6de0c266549.png";